/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { platformKillswitchesPlatformKillswitchesNumberActivatePrescription } from "../funcs/platformKillswitchesPlatformKillswitchesNumberActivatePrescription.js";
import { platformKillswitchesPlatformKillswitchesNumberChangePrescription } from "../funcs/platformKillswitchesPlatformKillswitchesNumberChangePrescription.js";
import { platformKillswitchesPlatformKillswitchesNumberDeactivatePrescription } from "../funcs/platformKillswitchesPlatformKillswitchesNumberDeactivatePrescription.js";
import { platformKillswitchesPlatformKillswitchesNumberGetPrescription } from "../funcs/platformKillswitchesPlatformKillswitchesNumberGetPrescription.js";
import { platformKillswitchesPlatformKillswitchesNumberListDefinitions } from "../funcs/platformKillswitchesPlatformKillswitchesNumberListDefinitions.js";
import { platformKillswitchesPlatformKillswitchesNumberListPrescriptions } from "../funcs/platformKillswitchesPlatformKillswitchesNumberListPrescriptions.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListDefinitionsResponseBody } from "../models/components/listdefinitionsresponsebody.js";
import { PlatformKillswitchMutationResult } from "../models/components/platformkillswitchmutationresult.js";
import { PlatformKillswitchPrescription } from "../models/components/platformkillswitchprescription.js";
import {
  PlatformKillswitchesNumberActivatePrescriptionRequest,
  PlatformKillswitchesNumberActivatePrescriptionSecurity,
} from "../models/operations/platformkillswitchesnumberactivateprescription.js";
import {
  PlatformKillswitchesNumberChangePrescriptionRequest,
  PlatformKillswitchesNumberChangePrescriptionSecurity,
} from "../models/operations/platformkillswitchesnumberchangeprescription.js";
import {
  PlatformKillswitchesNumberDeactivatePrescriptionRequest,
  PlatformKillswitchesNumberDeactivatePrescriptionSecurity,
} from "../models/operations/platformkillswitchesnumberdeactivateprescription.js";
import {
  PlatformKillswitchesNumberGetPrescriptionRequest,
  PlatformKillswitchesNumberGetPrescriptionSecurity,
} from "../models/operations/platformkillswitchesnumbergetprescription.js";
import {
  PlatformKillswitchesNumberListDefinitionsRequest,
  PlatformKillswitchesNumberListDefinitionsSecurity,
} from "../models/operations/platformkillswitchesnumberlistdefinitions.js";
import {
  PlatformKillswitchesNumberListPrescriptionsRequest,
  PlatformKillswitchesNumberListPrescriptionsResponse,
  PlatformKillswitchesNumberListPrescriptionsSecurity,
} from "../models/operations/platformkillswitchesnumberlistprescriptions.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class PlatformKillswitches extends ClientSDK {
  /**
   * activatePrescription platformKillswitches
   */
  async platformKillswitchesNumberActivatePrescription(
    request: PlatformKillswitchesNumberActivatePrescriptionRequest,
    security?:
      | PlatformKillswitchesNumberActivatePrescriptionSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<PlatformKillswitchMutationResult> {
    return unwrapAsync(
      platformKillswitchesPlatformKillswitchesNumberActivatePrescription(
        this,
        request,
        security,
        options,
      ),
    );
  }

  /**
   * changePrescription platformKillswitches
   */
  async platformKillswitchesNumberChangePrescription(
    request: PlatformKillswitchesNumberChangePrescriptionRequest,
    security?: PlatformKillswitchesNumberChangePrescriptionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PlatformKillswitchMutationResult> {
    return unwrapAsync(
      platformKillswitchesPlatformKillswitchesNumberChangePrescription(
        this,
        request,
        security,
        options,
      ),
    );
  }

  /**
   * deactivatePrescription platformKillswitches
   */
  async platformKillswitchesNumberDeactivatePrescription(
    request: PlatformKillswitchesNumberDeactivatePrescriptionRequest,
    security?:
      | PlatformKillswitchesNumberDeactivatePrescriptionSecurity
      | undefined,
    options?: RequestOptions,
  ): Promise<PlatformKillswitchMutationResult> {
    return unwrapAsync(
      platformKillswitchesPlatformKillswitchesNumberDeactivatePrescription(
        this,
        request,
        security,
        options,
      ),
    );
  }

  /**
   * getPrescription platformKillswitches
   */
  async platformKillswitchesNumberGetPrescription(
    request: PlatformKillswitchesNumberGetPrescriptionRequest,
    security?: PlatformKillswitchesNumberGetPrescriptionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PlatformKillswitchPrescription> {
    return unwrapAsync(
      platformKillswitchesPlatformKillswitchesNumberGetPrescription(
        this,
        request,
        security,
        options,
      ),
    );
  }

  /**
   * listDefinitions platformKillswitches
   */
  async platformKillswitchesNumberListDefinitions(
    request?: PlatformKillswitchesNumberListDefinitionsRequest | undefined,
    security?: PlatformKillswitchesNumberListDefinitionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListDefinitionsResponseBody> {
    return unwrapAsync(
      platformKillswitchesPlatformKillswitchesNumberListDefinitions(
        this,
        request,
        security,
        options,
      ),
    );
  }

  /**
   * listPrescriptions platformKillswitches
   */
  async platformKillswitchesNumberListPrescriptions(
    request: PlatformKillswitchesNumberListPrescriptionsRequest,
    security?: PlatformKillswitchesNumberListPrescriptionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<
      PlatformKillswitchesNumberListPrescriptionsResponse,
      { cursor: string }
    >
  > {
    return unwrapResultIterator(
      platformKillswitchesPlatformKillswitchesNumberListPrescriptions(
        this,
        request,
        security,
        options,
      ),
    );
  }
}
